module.exports = __webpack_public_path__ + "static/media/DTMF_Click.aa6e9b1c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audios/DTMF_Click.mp3
// module id = 2603
// module chunks = 0